import PropTypes from "prop-types";
import React from "react";
import { Option } from "rsl-api-106/lib/types";

import {
  SVGAmex,
  SVGANCV,
  SVGCb,
  SVGCheck,
  SVGIdeal,
  SVGMaestro,
  SVGMasterCard,
  SVGPaypal,
  SVGSepa,
  SVGVisa,
} from "@components/_Layout/SVGIcons";

type PaymentLogoProps = {
  option: Option;
};

const PaymentLogo: React.FC<PaymentLogoProps> = ({ option }) => {
  let element: JSX.Element = <SVGCb />;
  let code = option?.code?.toLocaleLowerCase() ?? "";
  let label = option?.label?.toLocaleLowerCase() ?? "";

  //1 visa
  //2 master card
  //3 amex
  //4 aurore
  //5 cb

  if (code.includes("5") || label.includes("bleu")) {
    element = <SVGCb />;
  } else if (
    code.includes("chqc") ||
    code.includes("cheque") ||
    label.includes("chqc") ||
    label.includes("cheque")
  ) {
    element = <SVGCheck />;
  } else if (code.includes("1") || label.includes("visa")) {
    element = <SVGVisa />;
  } else if (
    code.includes("3") ||
    label.includes("amex") ||
    label.includes("american")
  ) {
    element = <SVGAmex />;
  } else if (parseInt(code) === 2 || label.includes("master")) {
    element = <SVGMasterCard />;
  } else if (code.includes("maestro") || label.includes("maestro")) {
    element = <SVGMaestro />;
  } else if (code.includes("sepa") || label.includes("sepa")) {
    element = <SVGSepa />;
  } else if (code.includes("paypal") || label.includes("paypal")) {
    element = <SVGPaypal />;
  } else if (code.includes("ideal") || label.includes("ideal")) {
    element = <SVGIdeal />;
  } else if (parseInt(code) === 28 || label.includes("vacance")) {
    element = <SVGANCV className="tw-w-full tw-h-full tw-object-contain" />;
  }

  return element;
};

PaymentLogo.propTypes = {
  //
};

export default PaymentLogo;
